import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aajgaeciibxwqbubnsvq.supabase.co';
const supabaseAnonKey = 'sb_publishable_luoIOr5_L2mYL2TvdtVtYw_-DU5UmMl';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
